import React from 'react';
import { Lightning } from '@phosphor-icons/react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';

const PRICING_ROWS = [
  { plan: 'Welcome Trial', words: 'Up to 3,000 words', price: 'Free (one-time)', priceClass: 'text-emerald-400' },
  { plan: 'Small Document', words: 'Up to 2,000 words', price: '£5' },
  { plan: 'Standard Document', words: 'Up to 5,000 words', price: '£10' },
  { plan: 'Large Document', words: '5,001+ words', price: '£15 + £3 / extra 1,000' },
  { plan: 'Song Lyrics', words: 'Analysis + suggestions per song', price: '£1 / song' },
];

export const ExtensionsModal = ({ open, onOpenChange, user, extensions, onPurchaseExtension }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="rounded-lg border-2 border-border max-w-2xl" data-testid="extensions-modal">
      <DialogHeader>
        <DialogTitle className="text-2xl font-medium tracking-tight font-serif">Pricing & Top Up</DialogTitle>
        <DialogDescription className="text-sm text-ash font-sans">
          Standard pricing per document and add-on packs to extend your free words. You currently have{' '}
          <span className="font-medium text-gold">{user?.free_words_remaining || 0}</span> free words.
        </DialogDescription>
      </DialogHeader>

      <div className="mt-2">
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-ash mb-3">Standard Pricing (per document)</p>
        <div className="border border-border">
          <table className="w-full text-sm">
            <thead className="bg-stone border-b border-border">
              <tr>
                <th className="text-left text-xs font-medium uppercase tracking-[0.2em] text-ash p-3">Plan</th>
                <th className="text-left text-xs font-medium uppercase tracking-[0.2em] text-ash p-3">Word Count</th>
                <th className="text-right text-xs font-medium uppercase tracking-[0.2em] text-ash p-3">Price</th>
              </tr>
            </thead>
            <tbody className="font-sans">
              {PRICING_ROWS.map((row) => (
                <tr key={row.plan} className="border-t border-border/60">
                  <td className="p-3 font-medium">{row.plan}</td>
                  <td className="p-3 text-bone">{row.words}</td>
                  <td className={`p-3 text-right font-medium ${row.priceClass || ''}`}>{row.price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-6">
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-ash mb-3">Extension Add-Ons (top up free words)</p>
        <div className="space-y-2">
          {extensions.map((ext) => (
            <div
              key={ext.id}
              className="p-4 border border-border bg-background hover:border-gold transition-colors cursor-pointer"
              onClick={() => onPurchaseExtension(ext.id)}
              data-testid={`extension-${ext.id}`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <Lightning size={20} weight="duotone" className="text-gold" />
                  <div>
                    <p className="font-medium font-serif">{ext.name}</p>
                    <p className="text-xs text-ash font-sans">+{ext.words.toLocaleString()} words</p>
                  </div>
                </div>
                <p className="text-xl font-medium font-serif text-gold">£{ext.price.toFixed(2)}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="text-xs text-center text-ash font-sans mt-3">
          Pay-as-you-go: £3 per 1,000 additional words.
        </p>
      </div>
    </DialogContent>
  </Dialog>
);
